import React, { useContext, useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { state_details_api } from '../api/api';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import $ from 'jquery';

function States() {
    const { loader, setLoader, stateList, setStateList } = useContext(MyContext);

    useEffect(() => {
        state_details_api_call();
    }, []);

    const state_details_api_call = async () => {
        setLoader(true);
        try {
            const res = await state_details_api();
            if (res.status === 200) {
                setStateList(res.data.data || []);
            }
            setLoader(false);
        } catch (error) {
            console.error("state api error", error);
        }
    };


    // data table 
    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Destroy any existing DataTable instance before initializing a new one
        if ($.fn.DataTable.isDataTable(tableId)) {
            table.DataTable().destroy();
        }

        // Initialize DataTable with scrollX for horizontal scrolling
        table.DataTable({
            paging: true,
            lengthChange: true,
            pageLength: 10,
            lengthMenu: [5, 10, 15, 20],
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            infoFiltered: "(filtered from _MAX_ total records)",
            // buttons: ['copy', 'excel', 'pdf', 'print'],
            // dom: 'Bfrtip',
            pagingType: 'full_numbers', // Pagination with full numbers
            language: {
                paginate: {
                    first: '«',
                    last: '»',
                    next: '›',
                    previous: '‹',
                }
            },
            drawCallback: function (settings) {
                const api = this.api();
                const info = api.page.info();
                const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
                const currentPage = info.page;
                const totalPages = info.pages;

                // Show only specific pages with ellipses
                $paginate.each(function (index) {
                    const pageIndex = parseInt($(this).text(), 10) - 1;
                    if (isNaN(pageIndex)) return; // Skip non-number buttons

                    if (
                        pageIndex === 0 ||
                        pageIndex === totalPages - 1 ||
                        (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
                    ) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                // Add ellipses if necessary
                if (currentPage > 2) {
                    $('<span class="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
                }
                if (currentPage < totalPages - 3) {
                    $('<span class="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
                }
            }
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [stateList]);

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">States</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>State</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    loader ? <Loader /> : (
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">State List</h3>
                                            </div>
                                            <div className="card-body">

                                                <div className='table-responsive'>
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>State</th>
                                                                <th>Country</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>


                                                        <tbody>
                                                            {
                                                                stateList && stateList.map((state, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{state?.state_name}</td>
                                                                        <td>{state?.country_name}</td>
                                                                        <td>
                                                                            <Link
                                                                                to="/city"
                                                                                state={{ stateId: state.state_id }}
                                                                                className="btn btn-naariyal-green"
                                                                            >
                                                                                Manage Cities
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )
                }
            </div>

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div>
    );
}

export default States;
